module.exports = __webpack_public_path__ + "static/img/news2-9.99acbe4b.jpg";